import { capitalize } from 'lodash';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import useMain from '../../../../hooks/useMain';
import http from '../../../../services/httpService';
import getCard from '../../../../utils/getCard';
import { numberWithCommas, titleCase } from '../../../../utils/helpers';
import { FlippingDebit } from '../../ingredients/cards';
import Image from './../../../common/image';
import PackageUpgradeForm from './packageUpgradeForm';

const PackageUpgrade = ({ history }) => {
	const { userData, theme, initData, onUserDataChanged } = useMain();
	const [isLoading, setIsLoading] = useState(false);
	const { currentCard, userCards } = userData;
	const activeCards = userCards.filter((c) => c.status === 'active');

	const plannerCard = getCard(currentCard.totalAmount, 'planner', initData);
	const { name, dailyBinaryLimit, sellLimit, withdrawLimit, limit, mlm, sponsor } = plannerCard;

	const handleRequestSubmit = async (formData) => {
		const { securityPassword } = formData;
		try {
			setIsLoading(true);
			const { data } = await http.upgradePackage({
				securityPassword,
			});
			setIsLoading(false);
			onUserDataChanged(data.data);
			toast.success(data.message);
			history.replace('/dashboard/plannerDashboard');
		} catch (ex) {
			setIsLoading(false);
			console.log(ex);
			if (ex && ex.response && ex.response.data) return toast.error(ex.response.data);
			if (ex && ex.message) return toast.error(ex.message);
		}
	};

	return (
		<div className='card myCards'>
			<div className='card-body'>
				{currentCard.type === 'investor' && activeCards.length > 0 ? (
					<>
						<div className='row gy-4 my-4 text-center align-items-center'>
							<div className='offset-lg-2 col-lg-3 col-12 text-center'>
								<FlippingDebit
									card={userData.currentCard.name}
									text={userData.bemchain.uid}
								/>
							</div>
							<div className='col-lg-2 col-12 text-center'>
								<Image
									className='packageUpgradeArrow'
									height='64px'
									fileName='arrow_right.webp'
								/>
							</div>

							<div className='col-lg-3 col-12 text-center'>
								<FlippingDebit
									card={plannerCard.name}
									text={userData.bemchain.uid}
								/>
							</div>
						</div>
						<div className='row my-4'>
							<div className='offset-xl-3 col-xl-2 col-12'>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Card Name:{' '}
									<span className={`text-set5-${theme}`}>{titleCase(name)}</span>
								</div>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Total Amount:{' '}
									<span className={`text-set5-${theme}`}>
										${numberWithCommas(currentCard.totalAmount / 1e6)}
									</span>
								</div>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Max Cap:{' '}
									<span className={`text-set5-${theme}`}>
										{initData.cards[currentCard.name].maxCap}%
									</span>
								</div>
							</div>
							<div className='col-xl-2 col-12'>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Daily Binary Limit:{' '}
									<span className={`text-set5-${theme}`}>
										${numberWithCommas(dailyBinaryLimit / 1e6)}
									</span>
								</div>

								<div className={`my-2 text-set3-${theme}`}>
									✔️ MLM:{' '}
									<span className={`text-set5-${theme}`}>{mlm} Levels</span>
								</div>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Sponsor Percentage:{' '}
									<span className={`text-set5-${theme}`}>{sponsor}%</span>
								</div>
							</div>
							<div className='col-xl-3 col-12'>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Internal Exchange Limit:{' '}
									<span className={`text-set5-${theme}`}>
										${numberWithCommas(sellLimit / 1e6)}
									</span>
								</div>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Withdraw Limit:{' '}
									<span className={`text-set5-${theme}`}>
										${numberWithCommas(withdrawLimit / 1e6)}
									</span>
								</div>
								<div className={`my-2 text-set3-${theme}`}>
									✔️ Transfer Limit:{' '}
									<span className={`text-set5-${theme}`}>
										${numberWithCommas(limit / 1e6)}
									</span>
								</div>
							</div>
						</div>
						<div className='row my-4'>
							<div className='offset-xl-3 col-xl-6 col-12 fs-5 text-center'>
								You can upgrade your current{' '}
								<span className={`fw-bold text-set2-${theme}`}>
									{capitalize(currentCard.name)} Investor{' '}
								</span>
								card to a{' '}
								<span className={`fw-bold text-set2-${theme}`}>
									{capitalize(plannerCard.name)} Planner
								</span>{' '}
								package with the specifications listed above. Would you like to
								proceed?
							</div>
						</div>
						<div className='row my-4'>
							<PackageUpgradeForm
								theme={theme}
								isLoading={isLoading}
								plannerCard={plannerCard}
								currentCard={currentCard}
								hasSP={userData.hasSP}
								options={initData.mmiConfig.contract.needOptions}
								onSubmit={handleRequestSubmit}
							/>
						</div>
					</>
				) : (
					<div className='row my-5'>
						<div className='col text-center'>
							<Image
								fileName='icons/warn.svg'
								height='100px'
								className='mb-3'
							/>
							<h4>
								This section is only available to <b>Investor</b> class users who
								wish to upgrade their package to a <b>Planner</b> package.
							</h4>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PackageUpgrade;
